import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { PROFILE_FRAGMENT, ProfileFragment } from "./profile.fragment";

export interface Data {
  user: ProfileFragment;
}

export const PROFILE_QUERY = gql`
  query getProfile {
    user: getProfile {
      ...Profile
    }
  }

  ${PROFILE_FRAGMENT}
`;

export const useProfileQuery = (
  options?: useQuery.Options<Data, unknown>,
): useQuery.Result<Data, unknown> =>
  useQuery<Data, unknown>(PROFILE_QUERY, options);
